import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export const sxInvisibleStyle: SxProps<Theme> = {
    opacity: 0,
    pointerEvents: 'none'
}